import { Content, Dialog, DialogContainer, Divider, Flex, Heading, ProgressCircle } from '@adobe/react-spectrum';
import { useSelector } from 'react-redux';
import RealTimeCustomerProfile from '@spectrum-icons/workflow/RealTimeCustomerProfile';
import React from 'react';

export function AvatarImage(props) {
    return (
        <>
            {props.avatarUrl && props.avatarUrl != '' ? (
                <img
                    src={props.avatarUrl}
                    style={{
                        borderRadius: '50%',
                        width: props.size,
                        height: props.size,
                        objectFit: 'cover',
                    }}
                />
            ) : (
                <>
                    {props?.showDefaultIcon ? (
                        <RealTimeCustomerProfile
                            UNSAFE_style={{
                                width: props.size,
                                height: props.size,
                            }}
                        />
                    ) : (
                        <div
                        // style={{
                        //     // backgroundColor: '#000000',
                        //     borderRadius: '50%',
                        //     width: props.size + 1,
                        //     height: props.size,
                        // }}
                        />
                    )}
                </>
            )}
        </>
    );
}
